import Configs from 'infrastructure/config/environment'

export function apiUrl(): string {
  return Configs().ApiUrl
}

export enum Environment {
  Development = 'development',
  Staging = 'staging',
  Production = 'production',
}

export function currentEnvironment() {
  const appUrl = Configs().AppUrl
  switch (true) {
    case appUrl.includes('app.kiddom'):
      return Environment.Production
    case appUrl.includes('app-staging.kiddom'):
      return Environment.Staging
    case appUrl.includes('app-dev.kiddom'):
      return Environment.Development
  }
}

export function httpOptions(): object {
  const options: any = {}
  options.headers = new Headers({ Accept: 'application/json' })
  options.credentials = 'include'
  return options
}
